import React from 'react';
import PermitMap from './PermitMap';

/** Historical Map route — delegates to GovOps-backed PermitMap. */
const Map = () => <PermitMap />;

export default Map;
